import { render } from "./shortcut_key.vue?vue&type=template&id=d4e71bae"
import script from "./shortcut_key.vue?vue&type=script&lang=js"
export * from "./shortcut_key.vue?vue&type=script&lang=js"

import exportComponent from "D:\\workspace_front\\syb\\syb_webchat\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__